var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container modal-dialog-full-width" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_vm.filterTitle)),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "modal-body modal-content-full-width" }, [
      _c(
        "div",
        _vm._l(_vm.statuses, function (status, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "member-item",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSelect(status)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(status))]),
              status === _vm.selectedStatus
                ? _c(
                    "span",
                    { staticClass: "check-mark" },
                    [_c("md-icon", [_vm._v("check_circle")])],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }